import React, { useState, useRef, useMemo, useEffect } from 'react';
import { useFetchWithBody, usePost } from '../../api/reactQueryCustomHooks';
import {
  Box, Button, Grid, Paper, Table, TableBody, TableCell, TableContainer,
  TableHead, TableRow, TextField, Typography, FormControl, InputLabel,
  Select, MenuItem, IconButton, InputAdornment, Popover, useMediaQuery, Chip, Alert, AlertTitle, ListSubheader,
  CircularProgress
} from '@mui/material';

import { format } from 'date-fns';
import { saveAs } from 'file-saver';
import * as XLSX from 'xlsx';
import { apiRoute, ENUM_MOD_NAME, ENUM_MOD_PARAMETER, getModMandatory } from '../../constants/enum';
import { useSelector } from 'react-redux';
import { jsPDF } from 'jspdf';
import 'jspdf-autotable';
import { Tab, Tabs } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { autoTable } from "jspdf-autotable"
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faClose, faDownload, faDownLong, faFilter, faInfo, faRefresh, faSearch } from '@fortawesome/free-solid-svg-icons';
import { ErrorCard, LoadingCard, MainContainer, MUIDataTable } from '../../components';
import { LocalizationProvider, DatePicker } from '@mui/x-date-pickers';
import dayjs from "dayjs"
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs"
import { head } from 'lodash';
import { toast } from 'react-toastify';

export const ALL_COLUMNS = {

  BrokerDesc: { label: "Broker", group: "broker" ,type:"string"},
  PartyName: { label: "Party", group: "none",type:"string" },
  Bill_Date: { label: "Date", group: "date",type:"date" },
  YearMonth: { label: "Month", group: "month",type:"string" },
  InvNo: { label: "InvNo", group: "none",type:"string" },
  L_Code: { label: "Lot No", group: "none" ,type:"string"},
  PktNo: { label: "Pkt No", group: "none",type:"string" },
  SL_Code: { label: "Mfg Lot No", group: "none" ,type:"string"},
  SPktNo: { label: "Mfg Pkt No", group: "none" ,type:"string"},
  Weight: { label: "Weight",type:"number" },
  Pcs: { label: "Pcs" ,type:"number"},
  Rate: { label: "Rate (₹)", rupees: true,type:"number",weighted: true },
  S_Rate: { label: "Rate ($)", dollar: true ,type:"number",weighted: true },
  Amount: { label: "Amount (₹)", rupees: true,type:"number" },
  AmountD: { label: "Amount ($)", dollar: true,type:"number" },
  DiscPer: { label: "Disc %",type:"number" },
  DiscAmt: { label: "Disc Amt",type:"number" },
  NetAmtRs: { label: "Net Amt (₹)", rupees: true,type:"number" },
  NETAMTD: { label: "Net Amt ($)", dollar: true ,type:"number"},
  GSTAmt: { label: "GST Amt (₹)", rupees: true ,type:"number"},
  TDSAmt: { label: "TDS Amt (₹)", rupees: true ,type:"number"},
  GST_Status: { label: "Gst Status", group: "none" ,type:"string"},
  S_Name: { label: "Shape", group: "none" ,type:"string"},
  Sh_Name: { label: 'Color', group: "none" ,type:"string"},
  Q_Name: { label: 'Clarity', group: "none" ,type:"string"},
  Stn_Lnth: { label: "Length", group: "none" ,type:"string"},
  Dia: { label: 'Dia', group: "none",type:"number" },
  LabId: { label: "Lab", group: "none" ,type:"string"},
  ReportNo: { label: "Report", group: "none" ,type:"string"},
  Cut: { label: 'Cut', group: "none",type:"string" },
  Polish: { label: 'Polish', group: "none" ,type:"string"},
  Symtry: { label: 'Sym', group: "none",type:"string" },
  Flrn: { label: "Flrn", group: "none",type:"string" },
};

export const getColumns = (groupBy, activeTab, useMktAsMfg = true) => {
  return Object.entries(ALL_COLUMNS)
    .filter(([key, col]) => {
      // Handle SL_Code
      if (key === "SL_Code") {
        if (!useMktAsMfg) {
          return groupBy === "none" || groupBy === "slcode";
        } else {
          return false;
        }
      }
      if (key === "L_Code") {
        if (useMktAsMfg) {
          return groupBy === "none" || groupBy === "slcode";
        }
      }
      if (key === "PartyName") {
        return groupBy === "none" || groupBy === "party";
      }

      if (key === "SPktNo") {
        return !useMktAsMfg && groupBy === "none";
      }

      // Handle grouped columns
      if (col.group && col.group !== groupBy) return false;

      // Handle currency tabs
      if (col.rupees && activeTab === "dollar") return false;
      if (col.dollar && activeTab === "rupees") return false;

      return true;
    })
    .map(([key, col]) => ({ key, ...col }));
};
;


const TradingReport = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const [tabValue, setTabValue] = useState(0);
  const [activeTab, setActiveTab] = useState('all');
  const { compCode,compName, startDate, endDate } = useSelector((state) => state.company);
  const tableRef = useRef(null);
  const [anchorEl, setAnchorEl] = useState(null);
  const [currentFilterColumn, setCurrentFilterColumn] = useState('');
  const [groupBy, setGroupBy] = useState('none');
  const [isUseMfgNoAsMktno, setIsUseMfgNoAsMktno] = useState(true)
  const [columnFilters, setColumnFilters] = useState({
    InvNo: '',
    Bill_Date: '',
    YearMonth: '',
    PartyName: '',
    L_Code: '',
    PktNo: '',
    SL_Code: '',
    SPktNo: '',
    Weight: '',
    Pcs: '',
    Rate: '',
    Amount: '',
    DiscPer: '',
    DiscAmt: '',
    NetAmtRs: '',
    GSTAmt: '',
    BrokerDesc: '',
    S_Name: '',
    GST_Status:'',
    Sh_Name: '',
    Q_Name: '',
    Stn_Lnth: '',
    Dia: 0,
    LabId: '',
    ReportNo: '',
    Cut: '',
    polish: '',
    Symtry: '',
    Flrn: '',
  });

  const [filters, setFilters] = useState({
    compCode: compCode,
    dy: '1',
    acYear: '1',
    billType: 'S',
    acType: '13',
    Ac_id: '',
    tradeOf: '',
    Trade_Type: 'ALL',
    fromDate: dayjs(Date()).format("YYYY-MM-DD"),// startDate.split('T')[0],
    toDate: dayjs(Date()).format("YYYY-MM-DD"),//endDate.split('T')[0]//new Date()
  });

   const exportColumnKeys = [
        "InvNo",
        "Bill_Date",
        "PartyName",
        "L_Code",
        "PktNo",
        "SL_Code",
        "SPktNo",
        "Weight",
        "Pcs",
        "Rate",
        "S_Rate",
        "Amount",
        "AmountD",
        "DiscPer",
        "DiscAmt",
        "NetAmtRs",
        "NETAMTD",
        "GSTAmt",
        "TDSAmt"
    ];

  const { isError: isErrorModSet, data: modSetting = [] } = useFetchWithBody({
    url: apiRoute.modSetting.getModSetting,
    queryKey: "fetchModSettingInwardItem",
    inputData: {
      mod_name: ENUM_MOD_NAME.GeneralSettings
    }
  })
  useEffect(() => {
    if (modSetting && modSetting.length > 0) {
      const mktSetting = getModMandatory(ENUM_MOD_PARAMETER.GeneralSetting.UseMfgNoAsMktNo, modSetting);
      setIsUseMfgNoAsMktno(mktSetting)
    }
  }, [modSetting])
  const { data: partyData = [] } = useFetchWithBody({
    url: apiRoute.salesData.getParties,
    queryKey: ['salesParties', filters.acType, filters.tradeOf],
    inputData: {
      compCode: compCode[0],
      acType: filters.acType,
      tradeOf: filters.tradeOf
    },
    enabled: !!filters.acType // Only fetch when acType has a value
  });

  const { mutate: fetchReportData, isPending: isLoading, isError, data: reportData = [], error } = usePost({
    queryKey: ['salesReport', filters],
    url: apiRoute.salesData.getData,
  });



  // Apply column filters to the data
  const filteredData = useMemo(() => {
    if (!reportData.length) return [];
    return reportData.filter(row => {
      return Object.entries(columnFilters).every(([key, value]) => {
        if (!value) return true;
        const rowValue = row[key] || '';
        return String(rowValue).toLowerCase().includes(String(value).toLowerCase());
      });
    });
  }, [reportData, columnFilters]);




  const filteredAndGroupedData = useMemo(() => {
    if (!reportData?.length) return [];

    // ---------- FILTER ----------
    // const filteredData = reportData.filter(row =>
    //   Object.entries(columnFilters).every(([key, value]) => {
    //     if (!value) return true;
    //     return String(row[key] ?? '')
    //       .toLowerCase()
    //       .includes(String(value).toLowerCase());
    //   })
    // );

    if (groupBy === 'none') return filteredData;

    // ---------- GROUP ----------
    const groupedData = {};

    const getGroupKey = (row) => {
      switch (groupBy) {
        case 'broker':
          return row.BrokerDesc || 'Unknown Broker';

        case 'date':
          return format(new Date(row.Bill_Date), 'yyyy-MM-dd');

        case 'month':
          return row.YearMonth || 'Unknown Month';

        case 'party':
          return row.PartyName || 'Unknown Party';

        case 'slcode': // MFG / LOT
          return isUseMfgNoAsMktno
            ? (row.L_Code || 'Unknown Lot')
            : (row.SL_Code || 'Unknown Lot');

        default:
          return 'all';
      }
    };
    
    const initGroup = (row, key) => ({
      groupKey: key,

      Bill_Date:
        groupBy === 'date'
          ? format(new Date(row.Bill_Date), 'dd-MMM-yyyy')
          : key,

      YearMonth:
        groupBy === 'month'
          ? row.YearMonth
          : key,

      PartyName:
        groupBy === 'party'
          ? row.PartyName
          : 'Multiple Parties',

      BrokerDesc:
        groupBy === 'broker'
          ? row.BrokerDesc
          : 'Multiple Brokers',

      SL_Code: row.SL_Code,
      L_Code: row.L_Code,

      PktNo: 0,
      Weight: 0,
      Pcs: 0,
      Rate: 0,
      S_Rate: 0,
      Amount: 0,
      AmountD: 0,
      DiscPer: 0,
      DiscAmt: 0,

      // 🔥 NET VALUES
      NetAmtRs: 0,
      NETAMTD: 0,

      GSTAmt: 0,
      TDSAmt: 0,

      // helpers
      _rateWeightedSum: 0,
      _sRateWeightedSum: 0,
      _discCount: 0,

      // bill tracker (only for non-lot grouping)
      _billSet: new Set(),

      _children: []
    });

    filteredData.forEach(row => {
      const key = getGroupKey(row);

      if (!groupedData[key]) {
        groupedData[key] = initGroup(row, key);
      }

      const group = groupedData[key];

      const add = (field) => {
        group[field] += Number(row[field]) || 0;
      };

      add('PktNo');
      add('Weight');
      add('Pcs');
      add('Amount');
      add('AmountD');
      add('DiscAmt');
      add('GSTAmt');
      add('NetAmtRs');
      add('NETAMTD');

      group.TDSAmt += Number(row.TDSAmt) || 0;


      // weighted rates
      group._rateWeightedSum +=
        (Number(row.Rate) || 0) * (Number(row.Weight) || 0);

      group._sRateWeightedSum +=
        (Number(row.S_Rate) || 0) * (Number(row.Weight) || 0);

      // average discount %
      if (row.DiscPer != null) {
        group.DiscPer =
          (group.DiscPer * group._discCount + Number(row.DiscPer)) /
          (group._discCount + 1);
        group._discCount += 1;
      }

      group._children.push(row);
    });

    // ---------- FINALIZE ----------
    return Object.values(groupedData)
      .map(({ _discCount, _rateWeightedSum, _sRateWeightedSum, _billSet, ...rest }) => ({
        ...rest,
        Rate: rest.Weight ? _rateWeightedSum / rest.Weight : 0,
        S_Rate: rest.Weight ? _sRateWeightedSum / rest.Weight : 0
      }))
      .sort((a, b) => {
        if (groupBy === 'date' || groupBy === 'month') {
          return new Date(a.Bill_Date) - new Date(b.Bill_Date);
        }
        return String(a.groupKey).localeCompare(String(b.groupKey));
      });

  }, [filteredData, columnFilters, groupBy, isUseMfgNoAsMktno]);


  //   if (!reportData?.length) return [];

  //   // ---------- FILTER ----------
  //   const filteredData = reportData.filter(row =>
  //     Object.entries(columnFilters).every(([key, value]) => {
  //       if (!value) return true;
  //       return String(row[key] ?? '')
  //         .toLowerCase()
  //         .includes(String(value).toLowerCase());
  //     })
  //   );

  //   if (groupBy === 'none') return filteredData;

  //   // ---------- GROUP ----------
  //   const groupedData = {};

  //   const getGroupKey = (row) => {
  //     switch (groupBy) {
  //       case 'broker':
  //         return row.BrokerDesc || 'Broker';
  //       case 'date':
  //         return format(new Date(row.Bill_Date), 'yyyy-MM-dd');
  //       case 'month':
  //         return row.YearMonth;
  //       case 'party':
  //         return row.PartyName || 'Unknown Party';
  //       case 'slcode':  // Use SL_Code or L_Code depending on isUseMfgNoAsMktno
  //         return isUseMfgNoAsMktno ? row.L_Code : row.SL_Code || 'Unknown SL_Code';
  //       default:
  //         return 'all';
  //     }
  //   };

  //   const initGroup = (row, key) => {
  //     if (isUseMfgNoAsMktno)
  //       return {
  //         groupKey: key,
  //         Bill_Date: groupBy === 'date' ? format(new Date(row.Bill_Date), 'dd-MMM-yyyy') : key,
  //         YearMonth: groupBy === 'month' ? row.YearMonth : key,
  //         PartyName: groupBy === 'party' ? row.PartyName : 'Multiple Parties',
  //         BrokerDesc: groupBy === 'broker' ? row.BrokerDesc : 'Multiple Brokers',

  //         L_Code: groupBy === 'slcode' ? row.L_Code : undefined, // store SL_Code for detail table

  //         PktNo: 0,
  //         Weight: 0,
  //         Pcs: 0,
  //         Rate: 0,
  //         S_Rate: 0,
  //         Amount: 0,
  //         AmountD: 0,
  //         DiscPer: 0,
  //         DiscAmt: 0,
  //         NetAmtRs: 0,
  //         NETAMTD: 0,
  //         GSTAmt: 0,
  //         TDSAmt: 0,

  //         // helpers for weighted average
  //         _rateWeightedSum: 0,
  //         _sRateWeightedSum: 0,
  //         _discCount: 0,

  //         _children: []
  //       }
  //     else return {

  //       groupKey: key,
  //       Bill_Date: groupBy === 'date' ? format(new Date(row.Bill_Date), 'dd-MMM-yyyy') : key,
  //       YearMonth: groupBy === 'month' ? row.YearMonth : key,
  //       PartyName: groupBy === 'party' ? row.PartyName : 'Multiple Parties',
  //       BrokerDesc: groupBy === 'broker' ? row.BrokerDesc : 'Multiple Brokers',

  //       SL_Code: groupBy === 'slcode' ? row.SL_Code : undefined, // store SL_Code for detail table

  //       PktNo: 0,
  //       Weight: 0,
  //       Pcs: 0,
  //       Rate: 0,
  //       S_Rate: 0,
  //       Amount: 0,
  //       AmountD: 0,
  //       DiscPer: 0,
  //       DiscAmt: 0,
  //       NetAmtRs: 0,
  //       NETAMTD: 0,
  //       GSTAmt: 0,
  //       TDSAmt: 0,

  //       // helpers for weighted average
  //       _rateWeightedSum: 0,
  //       _sRateWeightedSum: 0,
  //       _discCount: 0,

  //       _children: []
  //     }
  //   };

  //   filteredData.forEach(row => {
  //     const key = getGroupKey(row);

  //     if (!groupedData[key]) {
  //       groupedData[key] = initGroup(row, key);

  //     }

  //     const group = groupedData[key];

  //     // if (groupBy === 'slcode' && !group.SL_Code) {
  //     //   group.SL_Code = isUseMfgNoAsMktno ? row.L_Code : row.SL_Code;
  //     // }


  //     const add = (field) => {
  //       group[field] += Number(row[field]) || 0;
  //     };

  //     add('PktNo');
  //     add('Weight');
  //     add('Pcs');
  //     add('Amount');
  //     add('AmountD');
  //     add('DiscAmt');
  //     add('NetAmtRs');
  //     add('NETAMTD');
  //     add('GSTAmt');
  //     group.TDSAmt += parseFloat(row.TDSAmt ?? 0);

  //     // weighted rate calculation
  //     group._rateWeightedSum += (parseFloat(row.Rate) || 0) * (parseFloat(row.Weight) || 0);
  //     group._sRateWeightedSum += (parseFloat(row.S_Rate) || 0) * (parseFloat(row.Weight) || 0);

  //     // Average discount %
  //     if (row.DiscPer != null) {
  //       group.DiscPer = (group.DiscPer * group._discCount + parseFloat(row.DiscPer)) / (group._discCount + 1);
  //       group._discCount += 1;
  //     }

  //     group._children.push(row);
  //   });

  //   // ---------- FINALIZE ----------
  //   return Object.values(groupedData)
  //     .map(({ _discCount, _rateWeightedSum, _sRateWeightedSum, ...rest }) => ({
  //       ...rest,
  //       Rate: rest.Weight ? _rateWeightedSum / rest.Weight : 0,
  //       S_Rate: rest.Weight ? _sRateWeightedSum / rest.Weight : 0
  //     }))
  //     .sort((a, b) => {
  //       if (groupBy === 'date' || groupBy === 'month') {
  //         return new Date(a.Bill_Date) - new Date(b.Bill_Date);
  //       }
  //       return a.groupKey.localeCompare(b.groupKey);
  //     });

  // }, [reportData, columnFilters, groupBy, isUseMfgNoAsMktno]);




  //   const filteredAndGroupedData = useMemo(() => {
  //     if (!reportData.length) return [];

  //     // First apply column filters
  //     let data = reportData.filter(row => {
  //       return Object.entries(columnFilters).every(([key, value]) => {
  //         if (!value) return true;
  //         const rowValue = row[key] || '';
  //         return String(rowValue).toLowerCase().includes(String(value).toLowerCase());
  //       });
  //     });

  //     // Then apply grouping if selected
  //     if (groupBy !== 'none') {
  //       const groupedData = {};

  //       data.forEach(row => {
  //         let groupKey;
  // console.log(groupBy)
  //         switch (groupBy) {
  //           case 'broker':
  //             groupKey = row.BrokerDesc || 'Broker';
  //             break;
  //           case 'date':
  //             groupKey = format(new Date(row.Bill_Date), 'yyyy-MM-dd');
  //             break;
  //           case 'month':
  //             groupKey = row.YearMonth;// format(new Date(row.Bill_Date), 'yyyy-MM');
  //             break;
  //           case 'party':
  //             groupKey = row.PartyName || 'Unknown Party';
  //             break;
  //           default:
  //             groupKey = 'all';
  //         }

  //         if (!groupedData[groupKey]) {
  //           console.log(groupKey,"key")
  //           groupedData[groupKey] = {
  //             groupKey,
  //             Bill_Date: groupBy === 'date' ? format(new Date(row.Bill_Date), 'dd-MMM-yyyy'):groupKey,
  //             YearMonth: groupBy === 'month' ? row.YearMonth:groupKey,
  //             PartyName: groupBy === 'party' ? row.PartyName : 'Multiple Parties',
  //             L_Code: groupBy === 'none' ? row.L_Code : 'Multiple',
  //             PktNo: 0,
  //             SL_Code:'',
  //             SPktNo:'',
  //             Weight: 0,
  //             Pcs: 0,
  //             Rate: 0,
  //             S_Rate: 0,
  //             Amount: 0,
  //             AmountD: 0,
  //             DiscPer: 0,
  //             DiscAmt: 0,
  //             NetAmtRs: 0,
  //             NETAMTD: 0,
  //             GSTAmt: 0,
  //             TDSAmt: 0,
  //             BrokerDesc: groupBy === 'broker' ? row.BrokerDesc : 'Multiple Brokers',
  //             S_Name: '',
  //             Sh_Name: '',
  //             Q_Name: '',
  //             Stn_Lnth: '',
  //             Dia: 0,
  //             LabId: '',
  //             ReportNo: '',
  //             Cut: '',
  //             polish: '',
  //             Symtry: '',
  //             Flrn: '',
  //             _children: []
  //           };
  //         }

  //         // Sum up all numeric values
  //         groupedData[groupKey].PktNo += parseFloat(row.PktNo) || 0;
  //         groupedData[groupKey].Weight += parseFloat(row.Weight) || 0;
  //         groupedData[groupKey].Rate += parseFloat(row.Rate) || 0;
  //         groupedData[groupKey].S_Rate += parseFloat(row.S_Rate) || 0;
  //         groupedData[groupKey].Amount += parseFloat(row.Amount) || 0;
  //         groupedData[groupKey].AmountD += parseFloat(row.AmountD) || 0;
  //         groupedData[groupKey].DiscAmt += parseFloat(row.DiscAmt) || 0;
  //         groupedData[groupKey].NetAmtRs += parseFloat(row.NetAmtRs || 0) || 0;
  //         groupedData[groupKey].NETAMTD += parseFloat(row.NETAMTD || 0) || 0;
  //         groupedData[groupKey].GSTAmt += parseFloat(row.GSTAmt) || 0;
  //         groupedData[groupKey].TDSAmt += parseFloat(row.TDSAmt) || 0;

  //         // Calculate average for DiscPer
  //         if (row.DiscPer) {
  //           groupedData[groupKey].DiscPer = (
  //             (groupedData[groupKey].DiscPer * groupedData[groupKey]._children.length +
  //               parseFloat(row.DiscPer)) /
  //             (groupedData[groupKey]._children.length + 1))
  //         }

  //         // Store original rows for drill-down
  //         groupedData[groupKey]._children.push(row);
  //       });

  //       // Convert to array and sort
  //       data = Object.values(groupedData).sort((a, b) => {
  //         if (groupBy === 'date' || groupBy === 'month') {
  //           return new Date(a.Bill_Date) - new Date(b.Bill_Date);
  //         }
  //         return a.groupKey.localeCompare(b.groupKey);
  //       });
  //     }

  //     return data;
  //   }, [reportData, columnFilters, groupBy]);

  const handleFilterChange = (e) => {
    const { name, value } = e.target;
    setFilters(prev => ({ ...prev, [name]: value }));
  };



  // const handleTabChange = (event, newValue) => {
  //   setTabValue(newValue);
  //   setFilters(prev => ({ ...prev, isSummary: newValue === 1 }));
  // };ry


  const handleSubmit = (e) => {
    e.preventDefault();
    if ((filters.fromDate && filters.fromDate == 'Invalid Date')
      || (filters.toDate && filters.toDate == 'Invalid Date')) {
      toast.error("Invalid From Date / To Date", {
        "position": "top-center"
      })
    }
    else {
      const params = {
        ...filters,
        fromDate: filters.fromDate && filters.fromDate != null && filters.fromDate != 'Invalid Date'
          ? filters.fromDate
          : '',
        toDate: filters.toDate && filters.toDate != null && filters.toDate != 'Invalid Date'
          ? filters.toDate //format(filters.toDate, 'yyyy-MM-dd')
          : ''
      };
      fetchReportData({ data: params });
    }

    // refetch();
  };

  const handleReset = () => {
    setFilters({
      compCode: compCode.join(","),
      dy: '1',
      acYear: '1',
      billType: 'S',
      acType: '13',
      Ac_id: '',
      tradeOf: '',
      Trade_Type: 'ALL',
      fromDate: startDate,// new Date(new Date().setDate(new Date().getDate() - 30)),
      toDate: endDate//new Date()
    });
    const params = {
      compCode: compCode.join(","),
      dy: '1',
      acYear: '1',
      billType: 'S',
      acType: '13',
      Ac_id: '',
      tradeOf: '',
      Trade_Type: 'ALL',
      fromDate: startDate,
      toDate: endDate
    };
    fetchReportData({ data: params });
  };



  // const calculateTotals = () => {
  //   const totals = {
  //     PktNo: 0,
  //     Weight: 0,
  //     Rate: 0,
  //     S_Rate: 0,
  //     Amount: 0,
  //     AmountD: 0,
  //     DiscAmt: 0,
  //     NetAmtRs: 0,
  //     NETAMTD: 0,
  //     GSTAmt: 0,
  //     TDSAmt: 0
  //   };

  //   filteredData.forEach(row => {
  //     totals.PktNo += parseFloat(row.PktNo) || 0;
  //     totals.Weight += parseFloat(row.Weight) || 0;
  //     totals.Rate += parseFloat(row.Rate) || 0;
  //     totals.S_Rate += parseFloat(row.S_Rate) || 0;
  //     totals.Amount += parseFloat(row.Amount) || 0;
  //     totals.AmountD += parseFloat(row.AmountD) || 0;
  //     totals.DiscAmt += parseFloat(row.DiscAmt) || 0;
  //     totals.NetAmtRs += parseFloat(row.NetAmtRs || 0) || 0;
  //     totals.NETAMTD += parseFloat(row.NETAMTD || 0) || 0;
  //     totals.GSTAmt += parseFloat(row.GSTAmt) || 0;
  //     totals.TDSAmt += parseFloat(row.TDSAmt) || 0;
  //   });

  //   return totals;
  // };


  //const totals = calculateTotals();

  const getReportTitle = () => {
    switch (filters.billType) {
      case 'S': return 'Sales Report';
      case 'P': return 'Purchase Report';
      case 'T': return 'Sales Return Report';
      case 'N': return 'Purchase Return Report';
      default: return 'Report';
    }
  };

  const getTradeTypeLabel = () => {
    switch (filters.tradeOf) {
      case 'R': return 'Rough';
      case 'P': return 'Polish';
      case 'J': return 'Rejection';
      case 'U': return 'Non Makeable';
      default: return 'All Types';
    }
  };

    const safeDate = (val) => {
    const d = dayjs(val);
    return d.isValid() ? d : null;
  };


  const headCssStyle = { fontSize: "0.7rem", lineHeight: 1.3, textTransform: "uppercase", backgroundColor: '#f0f0f0', fontWeight: 600, color: '#3c3c3c' }
  const columns = useMemo(() => getColumns(groupBy, activeTab, isUseMfgNoAsMktno), [isUseMfgNoAsMktno, groupBy]);
  if (isError) {
    return <ErrorCard />
  }
  if (isLoading) {
    return <LoadingCard />
  }
  return (
    <MainContainer
      pageName={`Trading Report`}
      breadcrumbs={["Reports", "Trading Report"]}

    >
      <Box sx={{
        p: isMobile ? 1 : 3,
        backgroundColor: 'background.default',
        minHeight: '100vh',

      }}>
        {/* Header Section */}
        <Box sx={{
          display: 'flex',
          flexDirection: { xs: 'column', md: 'row' },
          justifyContent: 'space-between',
          alignItems: { xs: 'flex-start', md: 'center' },
          gap: 2,
          mb: 1,
          p: 1,
          backgroundColor: 'background.paper',
          borderRadius: 3,
          boxShadow: '0px 2px 10px rgba(0, 0, 0, 0.08)'
        }}>
          <Typography variant="h4" sx={{
            fontSize: isMobile ? '1rem' : '1.3rem',
            fontWeight: 400,
            color: 'primary.main',
            letterSpacing: -0.5
          }}>
            {getReportTitle()}
          </Typography>

          {reportData.length > 0 && (
            <Box sx={{
              display: 'flex',
              flexWrap: 'wrap',
              gap: 1,
              alignSelf: { xs: 'stretch', md: 'center' }
            }}>
              {/* <Button
                variant="contained"
                color="success"
                startIcon={<FontAwesomeIcon icon={faDownload} />}
                onClick={exportToExcel}
                disabled={filteredData.length === 0}
                sx={{
                  textTransform: 'none',
                  fontWeight: 500,
                  px: 3,
                  borderRadius: 2,
                  fontSize: "0.8rem",
                  boxShadow: 'none',
                  '&:hover': { boxShadow: '0px 3px 5px rgba(0, 0, 0, 0.2)' }
                }}
              >
                Export Excel
              </Button>

              <Button
                variant="contained"
                color="error"
                startIcon={<FontAwesomeIcon icon={faDownLong} />}
                onClick={exportToPDF}
                disabled={filteredData.length === 0}
                sx={{
                  textTransform: 'none',
                  fontWeight: 500,
                  px: 3,
                  borderRadius: 2,
                  fontSize: "0.8rem",
                  boxShadow: 'none',
                  '&:hover': { boxShadow: '0px 3px 5px rgba(0, 0, 0, 0.2)' }
                }}
              >
                Export PDF
              </Button> */}
            </Box>
          )}
        </Box>

        {/* Filters Section */}
        <Paper sx={{
          p: isMobile ? 1 : 3,
          mb: 1,
          borderRadius: 3,
          boxShadow: '0px 2px 10px rgba(0, 0, 0, 0.08)',
          backgroundColor: 'background.paper'
        }}>
          <form onSubmit={handleSubmit}>
            <Grid container spacing={2}>
              {/* Hidden fields */}
              <Grid item xs={12} sm={6} md={3} sx={{ display: 'none' }}>
                <TextField fullWidth label="Company Code" name="compCode" value={filters.compCode} />
              </Grid>
              <Grid item xs={12} sm={6} md={3} sx={{ display: 'none' }}>
                <TextField fullWidth label="DY" name="dy" value={filters.dy} />
              </Grid>
              <Grid item xs={12} sm={6} md={3} sx={{ display: 'none' }}>
                <TextField fullWidth label="AC Year" name="acYear" value={filters.acYear} />
              </Grid>



              {/* Visible filters - First Row */}
              <Grid item xs={12} sm={6} md={3}>
                <FormControl fullWidth variant="outlined" size="small">
                  <InputLabel sx={{ fontSize: '0.875rem' }}>Bill Type</InputLabel>
                  <Select
                    name="billType"
                    value={filters.billType}
                    onChange={(e) => {
                      const selectedValue = e.target.value;
                      let acType = '';

                      if (selectedValue === 'S') acType = '13';
                      else if (selectedValue === 'P') acType = '11';
                      else if (selectedValue === 'T') acType = '14';
                      else if (selectedValue === 'N') acType = '12';

                      setFilters(prev => ({
                        ...prev,
                        billType: selectedValue,
                        acType: acType
                      }));
                    }}
                    label="Bill Type"
                    sx={{ borderRadius: 2 }}
                  >
                    <MenuItem value="S">Sales</MenuItem>
                    <MenuItem value="P">Purchase</MenuItem>
                    <MenuItem value="T">Sales Return</MenuItem>
                    <MenuItem value="N">Purchase Return</MenuItem>
                  </Select>
                </FormControl>
              </Grid>

              <Grid item xs={12} sm={6} md={3}>
                <FormControl fullWidth variant="outlined" size="small">
                  <InputLabel sx={{ fontSize: '0.875rem' }}>Trade Of (Optional)</InputLabel>
                  <Select
                    name="tradeOf"
                    value={filters.tradeOf}
                    onChange={handleFilterChange}
                    label="Trade of"
                    sx={{ borderRadius: 2 }}
                  >
                    <MenuItem value="">None</MenuItem>
                    <MenuItem value="R">Rough</MenuItem>
                    <MenuItem value="P">Polish</MenuItem>
                    <MenuItem value="J">Rejection</MenuItem>
                    <MenuItem value="U">Non Makeable</MenuItem>
                  </Select>
                </FormControl>
              </Grid>

              <Grid item xs={12} sm={6} md={3}>
                <FormControl fullWidth variant="outlined" size="small">
                  <InputLabel id="party-label" sx={{ fontSize: '0.875rem' }}>Account</InputLabel>
                  <Select
                    labelId="party-label"
                    name="Ac_id"
                    value={filters.Ac_id || ''}
                    onChange={(e) => {
                      setFilters(prev => ({
                        ...prev,
                        Ac_id: e.target.value
                      }));
                    }}
                    label="Party"
                    sx={{ borderRadius: 2 }}
                  >
                    <MenuItem value="">
                      <em>None</em>
                    </MenuItem>
                    {partyData.map(party => (
                      <MenuItem key={party.AC_ID} value={party.AC_ID}>
                        {party.AC_DESC}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>

              <Grid item xs={12} sm={6} md={3}>
                <FormControl fullWidth variant="outlined" size="small">
                  <InputLabel sx={{ fontSize: '0.875rem' }}>Trade Type</InputLabel>
                  <Select
                    name="Trade_Type"
                    value={filters.Trade_Type || 'ALL'}
                    onChange={handleFilterChange}
                    label="Trade Type"
                    sx={{ borderRadius: 2 }}
                  >
                    <MenuItem value="ALL">All</MenuItem>
                    <MenuItem value="EXPORT/IMPORT">Export/Import</MenuItem>
                    <MenuItem value="Local">Local</MenuItem>
                  </Select>
                </FormControl>
              </Grid>

              {/* Date Range Row */}
              <Grid item xs={12} sm={6} md={3}>
                <FormControl fullWidth>
                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DatePicker
                      label={"From Date"}
                      views={["day", "month", "year"]}
                      format="DD/MM/YYYY"
                      value={safeDate(
                        filters.fromDate
                          ? dayjs(filters.fromDate)
                          : filters.fromDate)
                      }
                      onChange={(newValue) => {
                        setFilters((prev) => {
                          return {
                            ...prev,
                            fromDate: newValue != '' && newValue != 'Invalid Date' ?
                              dayjs(newValue).format("YYYY-MM-DD") : null,
                          };
                        });
                      }}
                      slotProps={{
                        textField: { size: "small", },
                      }}
                    />
                  </LocalizationProvider>

                </FormControl>
              </Grid>

              <Grid item xs={12} sm={6} md={3}>
                <FormControl fullWidth>
                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DatePicker
                      label={"To Date"}
                      views={["day", "month", "year"]}
                      format="DD/MM/YYYY"
                      value={
                        filters.toDate
                          ? dayjs(filters.toDate)
                          : filters.toDate
                      }
                      onChange={(newValue) => {
                        setFilters((prev) => {
                          return {
                            ...prev,
                            toDate: newValue != '' && newValue != 'Invalid Date' ?
                              dayjs(newValue).format("YYYY-MM-DD") : null,
                          };
                        });
                      }}
                      slotProps={{
                        textField: { size: "small", },
                      }}
                    />
                  </LocalizationProvider>

                </FormControl>
              </Grid>

              <Grid item xs={12} sm={6} md={3}>
                <FormControl fullWidth variant="outlined" size="small">
                  <InputLabel sx={{ fontSize: '0.875rem' }}>Order By</InputLabel>
                  <Select
                    label="Order By"
                    value={groupBy}
                    onChange={(e) => setGroupBy(e.target.value)}
                    sx={{ borderRadius: 2, fontSize: '0.8rem' }}
                  >
                    <ListSubheader sx={{ fontWeight: "800", backgroundColor: "#fafbfbff", fontSize: "0.7rem" }} >DETAIL :</ListSubheader>
                    <MenuItem sx={{ fontSize: "0.850rem" }} value="none">REPORT DETAIL</MenuItem>

                    <ListSubheader sx={{ fontWeight: "800", backgroundColor: "#fafbfbff", fontSize: "0.7rem" }}  >SUMMARY BY :</ListSubheader>
                    <MenuItem sx={{ fontSize: "0.850rem" }} value="broker">BROKER</MenuItem>
                    <MenuItem sx={{ fontSize: "0.850rem" }} value="date">DATE</MenuItem>
                    <MenuItem sx={{ fontSize: "0.850rem" }} value="month">MONTH</MenuItem>
                    <MenuItem sx={{ fontSize: "0.850rem" }} value="party">PARTY</MenuItem>
                    <MenuItem sx={{ fontSize: "0.850rem" }} value="slcode">{isUseMfgNoAsMktno ? "LOT NO" : "MFG LOT NO"}</MenuItem>
                  </Select>
                </FormControl>
              </Grid>
              <Grid item xs={12} sm={6} md={3} lg={2}>
                <Box sx={{
                  display: 'flex',
                  gap: 1.5,
                  flexDirection: { xs: 'row', sm: 'row-reverse' },
                  justifyContent: { xs: 'flex-start', sm: 'flex-end' }
                }}>


                  <Button
                    variant="outlined"
                    onClick={handleReset}
                    startIcon={<FontAwesomeIcon style={{ fontSize: "0.9rem" }} icon={faRefresh} />}
                    sx={{
                      minWidth: 100,
                      // py: 1,
                      borderRadius: 2,
                      fontWeight: 500,
                      textTransform: 'none',
                      borderWidth: 1.5,
                      '&:hover': { borderWidth: 1.5 },
                      flexGrow: { xs: 1, sm: 0 }
                    }}
                  >
                    Reset
                  </Button>
                  <Button
                    variant="contained"
                    color="primary"
                    type="submit"
                    disabled={isLoading}
                    startIcon={isLoading ? <CircularProgress size={20} color="inherit" /> :
                      <FontAwesomeIcon style={{ fontSize: "0.9rem" }} icon={faSearch} />}
                    sx={{
                      minWidth: 100,
                      // py: 1,
                      borderRadius: 2,
                      fontWeight: 500,
                      textTransform: 'none',
                      flexGrow: { xs: 1, sm: 0 }
                    }}
                  >
                    {isLoading ? 'Searching' : 'Search'}
                  </Button>
                </Box>
              </Grid>

              {/* Tabs and Reset Section */}
              <Grid item xs={12}>
                <Box sx={{
                  display: 'flex',
                  flexDirection: { xs: 'column', sm: 'row' },
                  justifyContent: 'space-between',
                  alignItems: { xs: 'flex-start', sm: 'flex-end' },
                  gap: 2,
                  p: 1,
                  backgroundColor: 'background.default',
                  borderRadius: 2,
                  border: '1px solid',
                  borderColor: 'divider'
                }}>
                  <Box sx={{
                    display: 'flex',
                    flexDirection: { xs: 'column', sm: 'row' },
                    gap: 3,
                    width: '100%'
                  }}>
                    {/* Currency Type Tabs */}
                    <Box sx={{ flex: 1, minWidth: 0 }}>
                      <Typography variant="subtitle2" color="text.secondary" gutterBottom sx={{
                        fontWeight: 600
                        , marginBottom: "0px",
                      }}>
                        CURRENCY TYPE
                      </Typography>
                      <Tabs
                        value={activeTab}
                        onChange={(e, newValue) => setActiveTab(newValue)}
                        variant="scrollable"
                        scrollButtons="auto"
                        size="small"
                        allowScrollButtonsMobile
                        sx={{

                          padding: "0px",
                          '& .MuiTabs-indicator': {
                            height: 2,
                            borderRadius: '3px 3px 0 0',
                            backgroundColor: 'primary.main'
                          },
                          "& .MuiBox-root": {
                            padding: "0px",
                          },
                        }}
                      >
                        <Tab
                          label="All"
                          value="all"
                          sx={{

                            //py: 1,
                            textTransform: 'none',
                            fontSize: '0.875rem',
                            fontWeight: 600,
                            color: activeTab === 'all' ? 'primary.main' : 'text.secondary'
                          }}
                        />
                        <Tab
                          label="₹"
                          value="rupees"
                          sx={{

                            // py: 1,
                            textTransform: 'none',
                            fontSize: '1rem',
                            fontWeight: 600,
                            color: activeTab === 'rupees' ? 'primary.main' : 'text.secondary'
                          }}
                        />
                        <Tab
                          label="$"
                          value="dollar"
                          sx={{

                            //py: 1,
                            textTransform: 'none',
                            fontSize: '1rem',
                            fontWeight: 600,
                            color: activeTab === 'dollar' ? 'primary.main' : 'text.secondary'
                          }}
                        />
                      </Tabs>
                    </Box>
                  </Box>

                  {/* Reset Button */}
                  {/* <Button
                  variant="outlined"
                  onClick={handleReset}
                  startIcon={<FontAwesomeIcon icon={faRefresh}  />}
                  size="small"
                  sx={{
                    textTransform: 'none',
                    borderRadius: 2,
                    px: 3,
                    py: 1,
                    fontSize: '0.8rem',
                    fontWeight: 600,
                    borderWidth: 2,
                    '&:hover': { borderWidth: 2 }
                  }}
                >
                  {isMobile ? 'Reset' : 'Reset'}
                </Button> */}
                </Box>
              </Grid>
            </Grid>
          </form>
        </Paper>

        {/* Error Message */}
        {isError && (
          <Alert severity="error" sx={{ mb: 3, borderRadius: 2 }}>
            <AlertTitle>Error</AlertTitle>
            {error.message}
          </Alert>
        )}

        {/* Data Table Section */}
        <Paper sx={{
          p: isMobile ? 1 : 1,
          borderRadius: 3,
          boxShadow: '0px 2px 10px rgba(0, 0, 0, 0.08)',
          backgroundColor: 'background.paper'
        }} ref={tableRef}>
          {/* Table Header */}


               {/* Data Table */}
          {reportData.length > 0 ? (
            <Box sx={{ width: "100%", overflowX: "auto" }}>
            <MUIDataTable
              data={filteredAndGroupedData}
              dataColumns={columns}
              reportTitle={filters?.billType == 'P' ? "Purchase Report" : filters?.billType == 'S' ? "Sale Report" : filters?.billType == "N" ? "Sale Return Report" : filters?.billType == "T" ? "Purchase Return Report" : "report"}
              orderGroup={groupBy}
              currency={activeTab}
              filterDate={filters}
              tradeLabel={`Trade: ${getTradeTypeLabel()}`}
              companyName={compName.join(",")}
              hideIfZeroKeys={["TDSAmt", "DiscAmt", "DiscPer", "GSTAmt"]}
              exportColumnKeys={exportColumnKeys}
              enableHeaderFilter={true}

            />
          </Box>   
          ) : (
            !isLoading && (
              <Box sx={{
                p: 4,
                textAlign: 'center',
                border: `1px dashed ${theme.palette.divider}`,
                borderRadius: 2,
                backgroundColor: 'background.default'
              }}>
                <Box sx={{
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  gap: 2
                }}>
                  <FontAwesomeIcon icon={faInfo} />
                  {/* <DescriptionOutlined sx={{
                  fontSize: 48,
                  color: 'text.disabled'
                }} /> */}
                  <Typography variant="h6" color="text.secondary">
                    No  data available
                  </Typography>
                  <Typography variant="body1" color="text.secondary">
                    Apply filters above to generate a report
                  </Typography>
                </Box>
              </Box>
            )
          )}
        </Paper>


      </Box>
    </MainContainer>
  );
};

export default TradingReport;
